import 'babel-polyfill';
import 'custom-event-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import ReactGA from 'react-ga';

// components
import { history, store } from './middleware';
import Routes from './routes';
import registerServiceWorker from './registerServiceWorker';

if (module.hot) {
  module.hot.accept();
}

if (process.env.REACT_APP_GA) {
  let isDev = process.env.NODE_ENV === 'development';
  let gaInitialized = false;

  const devLog = (...args) => {
    if (isDev) {
      // eslint-disable-next-line no-console
      console.log('[GA/Termly]', ...args);
    }
  };

  // GA's native opt-out switch. When true, analytics.js suppresses every hit,
  // so this also silences the pageviews fired from App.js.
  const GA_DISABLE_KEY = 'ga-disable-' + process.env.REACT_APP_GA;

  const enableGA = () => {
    window[GA_DISABLE_KEY] = false;
    if (!gaInitialized) {
      gaInitialized = true;
      devLog('Analytics consent granted — initializing Google Analytics');
      ReactGA.initialize(process.env.REACT_APP_GA, {
        debug: isDev,
        gaOptions: isDev
          ? {
              cookieDomain: 'none'
            }
          : {}
      });
    } else {
      devLog('Analytics consent restored — re-enabling Google Analytics');
    }
    // Track the current pageview now that consent is (re)granted, since App
    // may have mounted or navigated while tracking was disabled.
    ReactGA.pageview(window.location.pathname + window.location.search);
  };

  const disableGA = () => {
    window[GA_DISABLE_KEY] = true;
    if (gaInitialized) {
      devLog('Analytics consent revoked — Google Analytics tracking disabled');
    }
  };

  // Termly reports consent either as a map ({ analytics: true, ... }) from
  // getConsentState() or as a `categories` array from the `consent` event.
  const hasAnalyticsConsent = consent => {
    if (!consent) return false;
    if (Array.isArray(consent.categories)) {
      return consent.categories.indexOf('analytics') !== -1;
    }
    return consent.analytics === true;
  };

  const applyConsent = consent => {
    devLog(
      'Consent changed:',
      consent,
      '→ analytics allowed:',
      hasAnalyticsConsent(consent)
    );
    if (hasAnalyticsConsent(consent)) {
      enableGA();
    } else {
      disableGA();
    }
  };

  // Termly is injected asynchronously by the <Termly /> component, so it may
  // not exist yet at load time. Poll briefly until it's available, then read
  // the current consent state and subscribe to future changes.
  const waitForTermly = () => {
    if (window.Termly && typeof window.Termly.on === 'function') {
      devLog('Termly detected and active');
      if (typeof window.Termly.getConsentState === 'function') {
        const consentState = window.Termly.getConsentState();
        devLog('Current consent state:', consentState);
        applyConsent(consentState);
      }
      window.Termly.on('consent', applyConsent);
    } else {
      window.setTimeout(waitForTermly, 250);
    }
  };

  waitForTermly();
}

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Routes />
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js